import styled, { css } from 'styled-components';
import {
  componentMaxWidths,
  horizontaFluidPaddings,
  medias,
} from '@/utils/sizes';
import { TComponentmarginTopPage, TComponentWidth } from '@/types/global';

export const ComponentContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    ![
      'marginBtm',
      'width',
      'pageType',
      'marginBottomOnMobile',
      'marginTopPage',
    ].includes(prop),
})<{
  marginBtm: string;
  width: TComponentWidth;
  pageType: 'project' | 'page';
  marginBottomOnMobile?: string;
  marginTopPage: TComponentmarginTopPage;
}>`
  position: relative;
  box-sizing: border-box;
  width: 100%;

  ${
    // Por alguna razón en prod este css no tiene especificidad (en dev si), de momento añadimos !important
    ({
      width,
      pageType,
      marginBottomOnMobile,
      marginTopPage,
      marginBtm,
    }) => css`

    opacity: 0;

    &[data-animation='none'] {
      opacity: 1;
    }

    &.reveal-anim {
      opacity: 0;
    }

    &.component-container {
      --component-padding: ${horizontaFluidPaddings[pageType || 'page']?.[width || 'main']};

      margin-top: ${marginTopPage ? `var(--mg-top-page-${marginTopPage})` : '0'};
      padding-right: var(--component-padding);
      padding-left: var(--component-padding);
      margin-bottom: ${marginBtm};


      > div {
        max-width: ${componentMaxWidths[pageType]?.[width]};
        margin: 0 auto;
      }

      ${medias.max.desktopSm} {
        padding-right: calc(var(--component-padding) * 0.5);
        padding-left: calc(var(--component-padding) * 0.5);
      }
    
      ${medias.max.tablet} {
        ${
          width !== 'full' &&
          css`
            padding-right: var(--page-pd-mobile-tablet);
            padding-left: var(--page-pd-mobile-tablet);
          `
        }

      ${medias.max.mobile} {
        margin-bottom: ${marginBottomOnMobile};
      }
    }
  `
  }

  > * {
    margin-left: auto;
    margin-right: auto;
  }
`;
